import { ExternalIntegration, ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { useConnectAccount } from 'components/BrandKitCreationModal/useConnectAccount'
import { Chip } from 'components/Chip/Chip'
import { PlatformIcon } from 'screens/ScheduledPosts/PlatformIcon'
import { integrationToName } from 'components/IntegrationRequiredModal/IntegrationRequiredModal'
import { UserProfileGroup } from 'blaze-ui/icons'
import { useRootStore } from 'stores/RootStore'
import { BrandKitIntegrationsDrawer } from '../BrandKitIntegrationsDrawer/BrandKitIntegrationsDrawer'
import { InitializationDrawer } from 'components/Onboarding/CreateBrandStyleModal/InitializationDrawer'
import { Button } from 'blaze-ui/Button'

interface ConnectIntegrationProps {
  onConnect: (integrations: ExternalIntegration[]) => any
  platform?: ExternalIntegrationEnum | string | null
  as?: 'button' | 'chip'
}

const BRAND_KIT_SUPPORTED_PLATFORMS: string[] = [
  ExternalIntegrationEnum.LinkedIn,
  ExternalIntegrationEnum.Instagram,
  ExternalIntegrationEnum.Facebook,
]

export const ConnectIntegration = ({ onConnect, platform, as = 'chip' }: ConnectIntegrationProps) => {
  const connect = useConnectAccount({ onConnect, isSingleSelect: true, allowReconnect: true })
  const { drawersStore } = useRootStore()
  const { openDrawer } = drawersStore

  const handleConnect = () => {
    switch (platform) {
      case ExternalIntegrationEnum.Instagram:
        connect(ExternalIntegrationEnum.Instagram)
        break
      case ExternalIntegrationEnum.Facebook:
        connect(ExternalIntegrationEnum.Facebook)
        break
      case ExternalIntegrationEnum.LinkedIn:
        connect(ExternalIntegrationEnum.LinkedIn)
        break
    }
  }

  const handleDrawerOpen = () => {
    openDrawer(InitializationDrawer, {
      component: () => <BrandKitIntegrationsDrawer handleConnect={connect} />,
    })
  }

  // If platform is not supported, render the generic connect option
  if (!BRAND_KIT_SUPPORTED_PLATFORMS.includes(platform as string)) {
    if (as === 'button') {
      return (
        <div>
          <Button variant="tertiary" size="lg" onPress={handleDrawerOpen} fullWidth>
            Connect Social Media Account
          </Button>
        </div>
      )
    }

    return (
      <div>
        <Chip variant="flat" onPress={handleDrawerOpen} selectable={false}>
          <UserProfileGroup color="var(--dark-80)" />
          Connect Social Media Account
        </Chip>
      </div>
    )
  }

  // For supported platforms, render platform-specific connect option
  if (as === 'button') {
    return (
      <div>
        <Button variant="tertiary" size="lg" onPress={handleConnect} fullWidth>
          Connect {integrationToName[platform as ExternalIntegrationEnum]} Account
        </Button>
      </div>
    )
  }

  return (
    <div>
      <Chip variant="flat" onPress={handleConnect} selectable={false}>
        <PlatformIcon platform={platform as ExternalIntegrationEnum} size={20} />
        Connect {integrationToName[platform as ExternalIntegrationEnum]} Account
      </Chip>
    </div>
  )
}
